import React from 'react';
import PropTypes from 'prop-types';
import {
  Section,
  SectionTitle,
  LinksList,
  Link,
  VideoContainer,
  Video,
} from './TyreMedia.style';

const TyreMedia = ({ media, t }) => {
  const hasVideos = media.productVideo && media.productVideo.length > 0;
  const hasLinks = media.microsite_b2b_link || media.microsite_productline_link;

  if (!hasVideos && !hasLinks) return null;

  return (
    <Section>
      <SectionTitle>Dodatni viri</SectionTitle>
      
      {hasVideos && (
        <VideoContainer>
          {media.productVideo.map((video, index) => (
            <Video key={index} controls>
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </Video>
          ))}
        </VideoContainer>
      )}

      {hasLinks && (
        <LinksList>
          {media.microsite_b2b_link && (
            <Link href={media.microsite_b2b_link} target="_blank" rel="noopener noreferrer">
              <i className="mdi mdi-briefcase-outline" />
              B2B Microsite
            </Link>
          )}
          {media.microsite_productline_link && (
            <Link href={media.microsite_productline_link} target="_blank" rel="noopener noreferrer">
              <i className="mdi mdi-package-variant" />
              Product Line Microsite
            </Link>
          )}
        </LinksList>
      )}
    </Section>
  );
};

TyreMedia.propTypes = {
  media: PropTypes.object.isRequired,
};

export default TyreMedia;

